import { HgSupportedLanguage } from '@smg-real-estate/domus';

import { type PriceDistributionData } from '@/models/iazi/queries/getPriceDistributionResponse';
import { type PriceEvolutionResponse } from '@/models/iazi/queries/getPriceEvolutionResponse';
import { type PriceRoomDistributionResponse } from '@/models/iazi/queries/getPriceRoomDistributionResponse';
import { type PriceValueResponse } from '@/models/iazi/queries/getPriceValueResponse';
import { MapGeoLevel } from '@/types';

export interface Data {
  price: PriceValueResponse;
  priceRoom: PriceRoomDistributionResponse;
  priceEvoData: PriceEvolutionResponse;
}

export interface PriceDistributions {
  [MapGeoLevel.Canton]: PriceDistributionData | null;
  [MapGeoLevel.Municipality]: PriceDistributionData | null;
  [MapGeoLevel.Town]: PriceDistributionData | null;
}

export interface UrlParams {
  param: string;
  zipCity: string;
}

export interface UrlParamsWithGeoLocation {
  [HgSupportedLanguage.DE]: UrlParams;
  [HgSupportedLanguage.EN]: UrlParams;
  [HgSupportedLanguage.IT]: UrlParams;
  [HgSupportedLanguage.FR]: UrlParams;
}

export const CITY_INDICATOR_IN_GEO_ID = '-city-';
